import React from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import { AiFooter } from '@atlassian/jira-atlassian-intelligence/src/common/ui/ai-footer/index.tsx';
import { useIsGenerating } from '@atlassian/jira-issue-smart-request-summary-state/src/controllers/state/index.tsx';
import { SummaryFeedbackCollector } from './feedback/index.tsx';
import { GenerationSkeleton } from './skeleton/index.tsx';

export const Footer = () => {
	const [isGenerating] = useIsGenerating();

	if (isGenerating) {
		return <GenerationSkeleton />;
	}

	return (
		<>
			<Flex xcss={containerStyle}>{!isGenerating && <SummaryFeedbackCollector />}</Flex>
			<AiFooter testId="issue-smart-request-summary.ui.footer.flex" isBeta={false} />
		</>
	);
};

export const FooterStreaming = () => {
	return (
		<>
			<Flex xcss={containerStyle}>
				<SummaryFeedbackCollector />
			</Flex>
			<AiFooter testId="issue-smart-request-summary.ui.footer.flex" isBeta={false} />
		</>
	);
};

const containerStyle = xcss({
	alignItems: 'center',
	justifyContent: 'space-between',
	paddingBlockStart: 'space.0',
	paddingBlockEnd: 'space.150',
	paddingInline: 'space.150',
	gap: 'space.100',
});
